import React, { useEffect, useRef, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
// import "../../../../_metronic/_assets/sass/pages/users/login-1.scss";
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../store/actions/index';
import { getBaseImageURL } from '../../../../helpers';
import { Col, Row } from 'react-bootstrap';
import './AuthLayout.scss';
export default function AuthLayout() {
  const dispatch = useDispatch();
  const globalImagePath = useRef(getBaseImageURL());
  const [logo, setLogo] = useState();

  useEffect(() => {
    dispatch(actions.getFrontGeneralSettings());
  }, [dispatch]);

  const { generalSettings } = useSelector((state) => state.settings);

  useEffect(() => {
    if (generalSettings?.siteLogo) {
      setLogo(generalSettings?.siteLogo);
    }
  }, [generalSettings?.siteLogo]);

  document.title = `Welcome to ${generalSettings?.siteName}`;
  return (
    <div className='auth-layout-wrapper d-flex flex-column justify-content-center flex-lg-row'>
      <div className='auth-layout-left-section w-100 w-lg-50 d-flex p-5 p-md-10'>
        <div className='w-100 d-flex flex-column justify-content-between'>
          <Link to='/' className='auth-layout-logo'>
            {logo ? (
              <img
                alt='Logo'
                width={220}
                height={50}
                src={`${globalImagePath.current}${logo}`}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = toAbsoluteUrl('media/misc/placeholder.png');
                }}
              />
            ) : null}
          </Link>
          <div className='auth-layout-left-section-image-wrapper'>
            <img height={100} width={100} src={toAbsoluteUrl('media/bg/login-left.png')} alt='image' fetchpriority='high' />
          </div>
          <div className='d-none flex-column-auto d-lg-flex justify-content-between'>
            <div className='opacity-70 fw-bold text-primary'>
              &copy; {new Date().getFullYear()} {generalSettings?.siteName}
            </div>
          </div>
        </div>
      </div>

      <div className='w-100 w-lg-50 d-flex flex-column flex-lg-row justify-content-center align-item-center position-relative p-0'>
        <div className='d-flex align-items-center justify-content-center w-100'>
          <Outlet />
        </div>

        <div className='d-flex d-lg-none align-items-center position-fixed bottom-0 translate-middle-x start-50 p-3 p-md-5'>
          <div className='text-dark-50 text-center text-nowrap fw-bold order-2 order-sm-1 my-2'>
            &copy; {new Date().getFullYear()} {generalSettings?.siteName}
          </div>
        </div>
      </div>
    </div>
  );
}
